import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import '../styles/TextScrollEffect.css';
import Video1 from '../styles/video/Video1.mp4';
import Video2 from '../styles/video/Video2.mp4';

gsap.registerPlugin(ScrollTrigger);

// Bloc texte ou vidéo
const AnimatedBlock = ({ children, from = 'left' }) => {
  const blockRef = useRef();

  useEffect(() => {
    const enterFrom = from === 'left' ? -100 : 100;

    gsap.fromTo(
      blockRef.current,
      { x: enterFrom, opacity: 0 },
      {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: blockRef.current,
          start: 'top 85%',
          toggleActions: 'play none none reverse',
        },
      }
    );
  }, [from]);

  return (
    <div ref={blockRef} className="animated-block">
      {children}
    </div>
  );
};

const TextBlock = ({ text }) => (
  <div className="text-block">
    {text}
  </div>
);

const VideoBlock = ({ src }) => (
  <div className="video-block">
    <div className="video-wrapper">
      <video src={src} autoPlay muted loop playsInline />
      <div className="video-overlay" />
    </div>
  </div>
);

export default function TextScrollEffect() {
  return (
    <div className="scroll-section">

      {/* Bloc 1 : Texte à gauche, Vidéo à droite */}
      <div className="section-row">
        <AnimatedBlock from="left">
          <TextBlock text="Basé en Méditerranée, Meta Yachts Services propose une approche complète pour entretenir, moderniser ou préparer votre bateau. Experts du refit et du conseil nautique, nous intervenons sur les voiliers et yachts de grande croisière, en aluminium et composite. Chaque projet bénéficie d’un suivi personnalisé, d’un haut niveau d’exigence, et d’une parfaite maîtrise des enjeux techniques du large." />
        </AnimatedBlock>
        <AnimatedBlock from="right">
          <VideoBlock src={Video1} />
        </AnimatedBlock>
      </div>

      {/* Bloc 2 : Vidéo à gauche, Texte à droite — inversé en mobile */}
      <div className="section-row reverse-on-mobile">
        <AnimatedBlock from="left">
          <TextBlock text="Meta Yachts Services met son expertise au service des navigateurs qui recherchent performance, sécurité et fiabilité. Du diagnostic structurel à l’optimisation du gréement, en passant par l’aménagement à bord ou l’accompagnement technique, nous répondons aux besoins des plaisanciers comme des aventuriers au long cours. Conseil personnalisé, formations à la navigation, service professionnel : une équipe passionnée, tournée vers la mer et ses défis." />
        </AnimatedBlock>
        <AnimatedBlock from="right">
          <VideoBlock src={Video2} />
        </AnimatedBlock>
      </div>

    </div>
  );
}
